module.exports = "/virtual-football-league/img/video/clubs/france/lille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/france/lille.png
// module id = 339
// module chunks = 4